(function () {
    'use strict';

    angular.module("imApp").factory("unitsService", ['$ihttp', function ($ihttp) {
        let service = {
            listUnits: function (parms) {
                return $ihttp.post({
                    method: 601,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
